import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class CustomIconService {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  init() {
    this.matIconRegistry.addSvgIcon('anti-shield', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/anti-shield.svg'));
    this.matIconRegistry.addSvgIcon('avatar', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/avatar-24px.svg'));
    this.matIconRegistry.addSvgIcon('avatar_add', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/avatar-add-24px.svg'));
    this.matIconRegistry.addSvgIcon(
      'avatar_network',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/avatar-network-24px.svg')
    );
    this.matIconRegistry.addSvgIcon('business', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/business-black-18dp.svg'));
    this.matIconRegistry.addSvgIcon(
      'checkmark-no-outline',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/check-48px.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'direction_left_right',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/direction-left-right-24px.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'fuel_electric',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/fuel-electric-24px.svg')
    );
    this.matIconRegistry.addSvgIcon('plug', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/plug-64px.svg'));
    this.matIconRegistry.addSvgIcon('emob-home', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/emob-privat-64px.svg'));
    this.matIconRegistry.addSvgIcon('csv', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/csv.svg'));
    this.matIconRegistry.addSvgIcon('doc', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/doc.svg'));
    this.matIconRegistry.addSvgIcon('jpeg', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/jpeg.svg'));
    this.matIconRegistry.addSvgIcon('pdf', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/pdf.svg'));
    this.matIconRegistry.addSvgIcon('txt', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/txt.svg'));
    this.matIconRegistry.addSvgIcon('xlsx', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/xlsx.svg'));
    this.matIconRegistry.addSvgIcon('hlf-home', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/e-mobilitet-hlf.svg'));
    this.matIconRegistry.addSvgIcon(
      'serviceagreement',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/serviceagreement.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'no-serviceagreement',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/no-serviceagreement.svg')
    );
    this.matIconRegistry.addSvgIcon('zip', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/zip.svg'));
    this.matIconRegistry.addSvgIcon('repair', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/home_repair_service.svg'));
    this.matIconRegistry.addSvgIcon('checkmark', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/check-circle-outline.svg'));
    this.matIconRegistry.addSvgIcon('ban', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/ban-circle-outline.svg'));
    this.matIconRegistry.addSvgIcon(
      'exclamationmark',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/exclamation-circle-outline.svg')
    );
    this.matIconRegistry.addSvgIcon('rfid-token', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/rfid-token.svg'));
    this.matIconRegistry.addSvgIcon('rfid-token-hlf', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/rfid-token-hlf.svg'));
    this.matIconRegistry.addSvgIcon('rfid-token-add', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/rfid-token-add.svg'));
    this.matIconRegistry.addSvgIcon(
      'rfid-token-assign',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/rfid-token-assign.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'support-guide',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/support-guide-icon.svg')
    );
    this.matIconRegistry.addSvgIcon('info', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/info-circle-outline.svg'));
  }
}
